import { inView, animate } from "motion";
import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import Navigation from "./Blocks/Header/navigation";
import WebComponents from "./js/WebComponents/index.js";
import '@glidejs/glide/dist/css/glide.core.min.css';
import "./main.css";
import Logos from "./Blocks/Logos/Logos.js";
import HomeBanner from "./Blocks/HomeBanner/HomeBanner.js";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock-upgrade";

Alpine.plugin(intersect);

window.Alpine = Alpine;
Alpine.start();

const domReady = () => {
  Navigation();
  initModules();
  initAnimations();

  window.clearAllBodyScrollLocks = clearAllBodyScrollLocks;

  document.addEventListener('modal:open', (e) => {
    if (e.detail && e.detail.overflowWrapper) {
      disableBodyScroll(e.detail.overflowWrapper);
    }
  });

  document.addEventListener('modal:close', (e) => {
    if (e.detail && e.detail.overflowWrapper) {
      clearAllBodyScrollLocks();
    }
  });

  document.querySelector("select")?.addEventListener("change", function () {
    this.classList.toggle("has-value", this.value !== "");
  });

  document.querySelectorAll('.giantpeach-contentscrollable .overflow-y-scroll').forEach(el => {
    setTimeout(_ => {
      el.scrollTo(0, 0);
    }, 100);
  })
};

/*

Each module should be treated as an individual block. 
Please pass each node as module param. 
Module path is case-sensitive. Wrong path will throw an error on dev server after running `npm run build`.

*/
function initModules() {
  new WebComponents();
  HomeBanner();

  const logoSliderNodes = document.querySelectorAll('.gp-logoslider');
  if (logoSliderNodes.length) {
    logoSliderNodes.forEach((slider) => {
      Logos(slider);
    });
  }
}

function initAnimations() {
  let transitionableBlocks = document.querySelectorAll(".transition-block");
  let inViewStop = inView(transitionableBlocks, ({ target }) => {
    animate(
      target,
      { opacity: 1, transform: "none" },
      { delay: 0.2, duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
    );

    return () => {
      animate(
        target,
        { opacity: 0, transform: "translateY(60px)" },
        { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
      );
    };
  });

  document.addEventListener("block:load", () => {
    transitionableBlocks = document.querySelectorAll(".transition-block");
    inViewStop();
    inViewStop = inView(transitionableBlocks, ({ target }) => {
      animate(
        target,
        { opacity: 1, transform: "none" },
        { delay: 0.2, duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
      );

      return () => {
        animate(
          target,
          { opacity: 0, transform: "translateY(60px)" },
          { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
        );
      };
    });
  });

  let transitionableFadeBlocks = document.querySelectorAll(".transition-block-fade");
  let inViewStopFade = inView(transitionableFadeBlocks, ({ target }) => {
    animate(
      target,
      { opacity: 1 },
      { delay: target.dataset.delay ?? 0.2, duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
    );

    return () => {
      animate(
        target,
        { opacity: 0 },
        { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
      );
    };
  });
  
  let transitionableBlocksProse = document.querySelectorAll(".transition-block-prose");
  inView(transitionableBlocksProse, ({ target }) => {
    target.classList.add('animated');

    return () => {
      target.classList.remove('animated');
    };
  });

  let transitionableBlocksClass = document.querySelectorAll(".transition-block-class");
  inView(transitionableBlocksClass, ({ target }) => {
    target.classList.add('animated');

    return () => {
      target.classList.remove('animated');
    };
  });

  let transitionableStaggerBlocks = document.querySelectorAll(".transition-block-stagger");

  transitionableStaggerBlocks.forEach(el => {
    const stagger = parseInt(el.dataset.stagger);

    if (stagger) {
      el.dataset.staggerItem = Array.from(
        el.closest(".stagger-child").parentNode.children,
      ).indexOf(el.closest(".stagger-child"));
    }
  });

  inView(transitionableStaggerBlocks, ({ target }) => {
    animate(
      target,
      { opacity: 1, transform: "none" },
      {
        delay: window.innerWidth < 992 ? 0 : parseInt(target.dataset.staggerItem) * 0.25,
        duration: 0.5,
        easing: [0.25, 0.1, 0.25, 1],
      },
    );

    return () => {
      animate(
        target,
        { opacity: 0, transform: "translateY(60px)" },
        { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] },
      );
    };
  });


}

document.addEventListener("DOMContentLoaded", domReady);
